import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const chapters = [
  { n: "01", title: "We stock the sizes others don't.", body: "From daily commuters to track-day slicks, our warehouse carries 18,000+ tires across 40+ brands — searchable in seconds." },
  { n: "02", title: "Real inventory. No phantom listings.", body: "What you see in the search is what's on our racks. Live stock counts mean no wasted trips and no bait-and-switch." },
  { n: "03", title: "Wholesale that respects your margin.", body: "Garages, fleets and resellers get tiered pricing, net terms and priority allocation. Apply once, buy for years." },
];

export const Manifesto = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const x = useTransform(scrollYProgress, [0, 1], ["12%", "-12%"]);

  return (
    <section ref={ref} className="relative z-10 bg-background py-20 sm:py-28 overflow-hidden" data-testid="manifesto">
      {/* editorial marquee accent */}
      <motion.div style={{ x }} className="whitespace-nowrap mb-16 select-none">
        <span className="font-display font-black uppercase tracking-tighter text-[18vw] sm:text-[12vw] leading-none text-foreground/[0.04]">
          GRIP · PERFORMANCE · TRUST · GRIP · PERFORMANCE · TRUST
        </span>
      </motion.div>

      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid gap-px bg-border border border-border">
        {chapters.map((c, i) => (
          <motion.div
            key={c.n}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: i * 0.08 }}
            className="bg-background grid md:grid-cols-12 gap-4 md:gap-8 p-8 sm:p-12 group hover:bg-card/40 transition-colors"
          >
            <div className="md:col-span-2 font-display font-black text-5xl sm:text-6xl text-primary/80 group-hover:text-primary transition-colors">
              {c.n}
            </div>
            <h3 className="md:col-span-6 font-display font-black uppercase tracking-tight text-3xl sm:text-4xl leading-[0.95]">
              {c.title}
            </h3>
            <p className="md:col-span-4 text-foreground/70 leading-relaxed self-end">{c.body}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
